import { InjectionToken } from '@angular/core'

export interface AngularCommonEnvironmentModel {
  appName: 'ilsEditor' | 'ilsPlayer' | 'ilsManager' | 'translationClient'
  serverUrl: string
  translationServiceURL: string
  playerUrl: string
  editorUrl: string
}

export const ANGULAR_COMMON_CONFIG = new InjectionToken<AngularCommonEnvironmentModel>('AngularCommonEnvironmentModel')
